import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { House, User } from '../../services/types';
import HouseCard from './HouseCard';

interface HousesListViewProps {
    houses: House[];
    users: User[];
    onEdit: (house: House) => void;
    onDelete: (publicId: string) => void;
}

const HousesListView: React.FC<HousesListViewProps> = ({
    houses,
    users,
    onEdit,
    onDelete,
}) => {
    const getUserName = (userId?: string | null): string => {
        if (!userId) return 'N/A';
        const user = users.find((u) => u.public_id === userId);
        return user ? user.nome : 'Unknown';
    };

    return (
        <Row className="g-4">
            {houses.map((house, index) => (
                <Col key={house.public_id} xs={12} sm={6} md={4} lg={3}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: index * 0.05 }}
                    >
                        <HouseCard
                            house={house}
                            ownerName={getUserName(house.user_id)}
                            onEdit={onEdit}
                            onDelete={onDelete}
                        />
                    </motion.div>
                </Col>
            ))}
        </Row>
    );
};

export default HousesListView;